import LanguageStrings from '../../../../i18n/locales'

export interface HeadCell {
  disablePadding: boolean
  id: string
  label: string
  numeric: boolean
  isDate: boolean
}

const KpiDetailsStrings = LanguageStrings().KpiDetails

export const getColumnsByKpi = (kpiDetailName: string): HeadCell[] => {
  switch (kpiDetailName) {
    case 'total-shipped-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'shippedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.ShipmentDate,
          isDate: true
        }
      ]
    case 'total-registered-shipped-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'shippedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.ShipmentDate,
          isDate: true
        }
      ]
    case 'total-registered-communicated-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        }
      ]
    case 'total-connected-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        }
      ]
    case 'total-stale-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'installedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        }
      ]
    case 'last-reads-alarms-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'valueString',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AlarmReportedDate,
          isDate: true
        }
      ]
    case 'total-reads-details-in-range':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'intervalLength',
          numeric: true,
          disablePadding: false,
          label: KpiDetailsStrings.IntervalLength,
          isDate: false
        }
      ]
    case 'ec-mode-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'value',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.ECLMode,
          isDate: false
        }
      ]
    case 'signal-strength-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'valueString',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.SignalStrength,
          isDate: false
        }
      ]
    case 'alarms-breakdown-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'numAlarms',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.NoOfAlarms,
          isDate: false
        },
        {
          id: 'status',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AlarmStatus,
          isDate: false
        },
        {
          id: 'selectedDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AlarmRaisedDate,
          isDate: true
        },
        {
          id: 'valueString',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.Severity,
          isDate: false
        }
      ]
    case 'firmware-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'lcState',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LifecycleState,
          isDate: false
        },
        {
          id: 'firmwareVersion',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.FWVersion,
          isDate: false
        }
      ]
    case 'battery-percent-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'value',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.BatteryPercentage,
          isDate: false
        }
      ]
    case 'asset-details-with-state':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'lcState',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LifecycleState,
          isDate: false
        },
        {
          id: 'value',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.TransitionDate,
          isDate: true
        }
      ]
    case 'spread-factor-details':
      return [
        {
          id: 'serialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.MeterSerialNumber,
          isDate: false
        },
        {
          id: 'assetType',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.AssetType,
          isDate: false
        },
        {
          id: 'cliponSerialNumber',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CliponSerialNumber,
          isDate: false
        },
        {
          id: 'installationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.InstallDate,
          isDate: true
        },
        {
          id: 'lastCommunicationDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.LastCommunicatedDate,
          isDate: true
        },
        {
          id: 'firstCommDate',
          numeric: false,
          disablePadding: false,
          label: KpiDetailsStrings.CommunicatedDate,
          isDate: true
        },
        {
          id: 'value',
          numeric: false,
          disablePadding: false,
          label: 'Spread Factor Mode', // needs to confirm
          isDate: false
        }
      ]
    default:
      return []
  }
}
